import { render, staticRenderFns } from "./TutorialesTurnos.vue?vue&type=template&id=ca3fe3f6&scoped=true"
import script from "./TutorialesTurnos.vue?vue&type=script&lang=js"
export * from "./TutorialesTurnos.vue?vue&type=script&lang=js"
import style0 from "./TutorialesTurnos.vue?vue&type=style&index=0&id=ca3fe3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3fe3f6",
  null
  
)

export default component.exports